import React from "react";
import { Script } from "gatsby";

type Props = {
  brand?: {
    name?: string;
  };
  channel?: string;
  pageTitle?: string;
  pageType?: string;
  tiktokAnalyticsID: string;
};

export default function TikTokAnalytics({
  brand = {},
  channel = "",
  pageTitle = "",
  pageType = "",
  tiktokAnalyticsID,
}: Props) {
  const trackingParams = {
    brand: brand?.name ?? "",
    content_category: channel,
    content_id: "ViewContent",
    content_name: pageTitle,
    content_type: pageType,
  };

  const trackingParamsStr = JSON.stringify(trackingParams);

  const isCustomEventEnabled =
    brand?.name &&
    ["breeze.co.th/"].includes(
      process.env.GATSBY_SITE_DOMAIN + process.env.GATSBY_PATH_PREFIX
    );

  const customEvent = isCustomEventEnabled
    ? `ttq.track("${trackingParams.brand}", { contents: [ ${trackingParamsStr} ] });`
    : "";

  return (
    <Script id={`tiktok-analytics-script-${tiktokAnalyticsID}`}>
      {`!function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
  )ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
      
        ttq.load("${tiktokAnalyticsID}");
        ttq.page();
        ttq.track("ViewContent", {
          contents: [ ${trackingParamsStr} ],
        });
        ${customEvent}
      }(window, document, 'ttq');`}
    </Script>
  );
}
